import moment from 'moment-timezone'

export const processTag = (t) => ({
  id: t.id,
  name: t.name,
  auto: t.auto || false,
  channelId: t.channel_id,
})

export const processCategory = (c) => ({
  id: c.id,
  extId: c.ext_id,
  name: c.name,
})

export const processGenre = (g) => ({
  id: g.id,
  extId: g.ext_id,
  name: g.name,
})

export const processTz = (tz) => ({
  name: tz.name,
})

export const processAnnouncement = (a) => ({
  id: a.id,
  extid: a.extid,
  name: a.name,
  description: a.description,
  streamURL: a.example_hls_url || '',
})

export const processBlackout = (b) => ({
  id: b.id,
  extid: b.extid,
  name: b.name,
  description: b.description,
  streamURL: b.example_hls_url || '',
})

export const assetToJsonAPI = (asset) => {
  const processed = {
    id: asset.id,
    type: asset.type,
    name: asset.name,
    description: asset.description,
    categories: asset.categories || [],
    genres: asset.genres || [],
    tags: asset.tags || [],
  }
  if (asset.vodType === 'episode') {
    processed.episode_index = asset.episodeIndex
  }
  if (asset.vodType === 'package') {
    processed.package_assets = []
    for (let i = 0; i < asset.assets.length; i += 1) {
      processed.package_assets.push({
        id: asset.assets[i].id,
        order: i + 1,
      })
    }
  }
  if (asset.posterId) {
    processed.pictures = [
      {
        picture_id: asset.posterId,
      },
    ]
  }
  return processed
}

// account
export const initAccount = {
  id: 0,
  createdAt: null,
  updatedAt: null,
  newPassword: '',
  confirmedPassword: '',
  email: '',
  firstname: '',
  lastname: '',
  company: '',
}

export const processUser = (user) => ({
  id: user.id,
  createTime: user.create_time,
  updateTime: user.update_time,
  firstName: user.first_name,
  lastName: user.last_name,
  username: user.username,
  groups: user.groups || [],
})

export const userToJsonAPI = (user) => ({
  id: user.id,
  first_name: user.firstName,
  last_name: user.lastName,
})

export const processAccount = (account) => ({
  id: account.id,
  createdAt: account.created_at,
  updatedAt: account.updated_at,
  newPassword: '',
  confirmedPassword: '',
  email: account.email,
  firstname: account.name.first || '',
  lastname: account.name.last || '',
  company: account.company || '',
})

export const processTimezone = (tz) => ({
  id: tz.id,
  name: tz.name,
})

export const processLayout = (layout) => ({
  id: layout.id,
  extId: layout.ext_id,
  name: layout.name,
  description: layout.description,
  pictureURL: layout.picture_url,
  bumper: layout.bumper,
  announce: layout.announce,
  ad: layout.ad,
  isActive: layout.ext_id !== 'in_content_advertising' && layout.ext_id !== 'custom',
})

export const processDummyEPG = (program) => ({
  id: program.id,
  name: program.name,
  repeat: Number(program.repeat),
  duration: Number(program.duration),
})

export const dummyEPGProgramToJson = (program) => ({
  id: program.id,
  name: program.name,
  repeat: program.repeat,
  duration: program.duration,
})

export const processTemplate = (t) => ({
  id: t.id,
  type: t.type,
  name: t.name,
  description: t.description,
  pictureURL: t.picture_url,
  streamURL: t.stream_url,
  settings: t.settings,
})

export const processChannelTemplate = (t) => {
  const processed = {
    id: t.id,
    type: t.type,
    state: t.state,
    pictureId: t.picture_id,
    picture: t.picture || '',
    streamURL: t.stream_url,
    template: {},
  }
  if (t.template) {
    processed.template = processTemplate(t.template)
  }
  return processed
}

export const processAutoSchedulerTag = (t) => {
  const processed = {
    proportion: t.proportion,
    tag: {},
  }
  if (t.tag) {
    processed.tag = processTag(t.tag)
  }
  return processed
}

export const processAutoSchedulerRule = (r) => ({
  id: r.id,
  intervalStart: r.interval_start,
  intervalEnd: r.interval_end,
  weight: r.weight,
  range: [r.interval_start, r.interval_end],
  level: r.weight,
  distance: r.min_repeat_interval,
  priorities: [],
  valid: false,
})

export const processChannel = (channel) => {
  const processed = {
    id: channel.id,
    createTime: channel.create_time,
    updateTime: channel.update_time,
    name: channel.name,
    description: channel.description,
    fccRating: channel.fcc_rating,
    logoId: channel.logo_id,
    logo: '',
    dvrDuration: channel.np_dvr_duration || 0,
    streamURLhlsv3: channel.stream_hls3_url,
    streamURLhlsv5: channel.stream_hls5_url,
    streamURL: '',
    streamFrameSrc: '',
    autoScheduler: channel.auto_scheduler,
    autoSchedulerDepth: channel.forward_scheduling_depth || 0,
    autoSchedulerTags: [],
    autoSchedulerRules: [],
    autoSchedulerSettings: channel.auto_scheduler_settings || {},
    watermark: {
      position: 'topLeft',
      size: '200',
    },
    watermarkPictureId: 0,
    watermarkPicture: '',
    layout: {},
    timezone: {},
    templates: [],
    currentProgram: {},
    xmltv: {
      lastImportTimeAuto: '',
      lastImportTimeCustom: '',
      resultURLAuto: '',
      resultURLCustom: '',
      userOutputURL: '',
    },
    dummyEPG: [],
    ads: {
      inContentAdvertising: false,
      adBlockDuration: 0,
      minInterval: 0,
      programSafeZoneLeft: 0,
      programSafeZoneRight: 0,
    },
    version: channel.version || 1,
    suspended: channel.suspended || false,
  }
  if (channel.logo) {
    processed.logo = channel.logo.blob
  }
  if (channel.watermark) {
    processed.watermark = {
      createTime: channel.watermark.create_time,
      updateTime: channel.watermark.update_time,
      position: channel.watermark.position ? channel.watermark.position : 'topLeft',
      size: channel.watermark.size ? channel.watermark.size : '200',
      state: channel.watermark.state,
      enabled: channel.watermark.enabled,
      transcodingUpdateRequired: channel.watermark.transcoding_update_required,
      pictureId: channel.watermark.picture_id,
    }
    processed.watermarkPictureId = channel.watermark.picture_id
    if (channel.watermark.picture) {
      processed.watermarkPicture = channel.watermark.picture.blob
    }
  }
  if (channel.xmltv) {
    processed.xmltv.lastImportTimeAuto = channel.xmltv.last_import_time_auto
    processed.xmltv.lastImportTimeCustom = channel.xmltv.last_import_time_custom
    processed.xmltv.resultURLAuto = channel.xmltv.url_auto
    processed.xmltv.resultURLCustom = channel.xmltv.url_custom
    processed.xmltv.userOutputURL = channel.xmltv.user_output_url
  }
  if (channel.dummy_epg) {
    processed.dummyEPG = channel.dummy_epg.map((e) => processDummyEPG(e))
  }
  if (channel.layout) {
    processed.layout = processLayout(channel.layout)
  }
  if (channel.timezone) {
    processed.timezone = processTimezone(channel.timezone)
  }
  if (channel.templates) {
    processed.templates = channel.templates.map((t) => processChannelTemplate(t))
  }
  if (channel.auto_scheduler_rules) {
    // eslint-disable-next-line max-len
    processed.autoSchedulerRules = channel.auto_scheduler_rules.map((r) => processAutoSchedulerRule(r))
  }
  if (channel.auto_scheduler_tags) {
    // eslint-disable-next-line max-len
    processed.autoSchedulerTags = channel.auto_scheduler_tags.map((t) => processAutoSchedulerTag(t))
  }
  if (channel.ads) {
    processed.ads = {
      inContentAdvertising: channel.ads.in_content_advertising,
      adBlockDuration: channel.ads.ad_block_duration,
      minInterval: channel.ads.min_interval,
      programSafeZoneLeft: channel.ads.program_safe_zone_left,
      programSafeZoneRight: channel.ads.program_safe_zone_right,
    }
  }
  return processed
}

export const processAssetOutput = (o) => {
  const processed = {
    id: o.id,
    state: o.state,
    type: o.type,
    streamURL: o.stream_url || '',
    channelId: o.channel_id,
    channel: {},
  }
  if (o.channel) {
    processed.channel = processChannel(o.channel)
  }
  return processed
}

export const processDistribution = (d) => {
  const processed = {
    id: d.id,
    name: d.name,
    createTime: d.create_time,
    updateTime: d.update_time,
    urls: {},
    whitelist: d.whitelist || [],
    channelId: d.channel_id,
  }
  for (const key in d.urls) {
    let streamURL = d.urls[key]
    streamURL = streamURL.replace('$origin', 'now')
    streamURL = streamURL.replace('$offset', '-1m_15s')
    streamURL = streamURL.replace(',', '_')
    processed.urls[key] = streamURL
  }
  return processed
}

export const processResource = (r) => {
  return {
    id: r.id,
    createTime: r.create_time,
    updateTime: r.update_time,
    type: r.type,
    category: r.category,
    state: r.state,
    streamURL: r.source_url || '',
    pictureId: r.picture_id || 0,
  }
}

export const processAsset = (asset) => {
  const processed = {
    id: asset.id,
    extId: asset.ext_id,
    type: asset.type,
    state: asset.state,
    createTime: asset.create_time,
    updateTime: asset.update_time,
    name: asset.name,
    description: asset.description,
    duration: asset.duration,
    year: asset.year || 0,
    // streamURL: asset.stream_url || '',
    pubTime: asset.pub_time,
    categories: [],
    genres: [],
    tags: [],
    mediaSource: {
      id: asset.media_source_id || 0,
      name: '',
    },
    outputs: [],
    streams: [],
    pictures: [],
    posterId: 0,
  }
  // if (asset.poster) {
    // processed.poster = asset.poster.blob
  // }
  if (asset.categories) {
    processed.categories = asset.categories.map((c) => processCategory(c))
  }
  if (asset.genres) {
    processed.genres = asset.genres.map((g) => processGenre(g))
  }
  if (asset.tags) {
    processed.tags = asset.tags.map((g) => processTag(g))
  }
  if (asset.pictures) {
    processed.pictures = asset.pictures.map((r) => processResource(r))
    for (let i = 0; i < asset.pictures.length; i += 1) {
      if (asset.pictures[i].category === 'poster') {
        processed.posterId = asset.pictures[i].picture_id
        break
      }
    }
  }
  if (asset.streams) {
    processed.streams = asset.streams.map((s) => processResource(s))
  }
  if (asset.outputs) {
    processed.outputs = asset.outputs.map((o) => processAssetOutput(o))
  }
  return processed
}

export const channelToJsonAPI = (channel) => {
  const processed = {
    id: channel.id,
    name: channel.name,
    description: channel.description,
    fcc_rating: channel.fccRating,
    logo_id: channel.logoId,
    auto_scheduler: channel.autoScheduler,
    forward_scheduling_depth: Number(channel.autoSchedulerDepth) || 0,
    templates: [],
    watermark: {},
    xmltv: {},
  }
  if (channel.watermark) {
    processed.watermark = {
      position: channel.watermark.position,
      size: channel.watermark.size,
      enabled: channel.watermark.enabled,
      transcoding_update_required: channel.watermark.transcodingUpdateRequired,
      picture_id: channel.watermarkPictureId,
    }
  }
  if (channel.xmltv) {
    processed.xmltv.last_import_time_custom = channel.xmltv.lastImportTimeCustom
    processed.xmltv.last_import_time_auto = channel.xmltv.lastImportTimeAuto
    processed.xmltv.user_output_url = channel.xmltv.userOutputURL
  }
  if (channel.layout) {
    processed.layout = { id: channel.layout.id }
  }
  if (channel.timezone) {
    processed.timezone = { id: channel.timezone.id }
  }
  if (channel.bumper && channel.bumper.id) {
    processed.templates.push({ template: { id: channel.bumper.id } })
  }
  if (channel.announcement && channel.announcement.id) {
    processed.templates.push({ template: { id: channel.announcement.id } })
  }
  if (channel.blackout && channel.blackout.id) {
    processed.templates.push({ template: { id: channel.blackout.id } })
  }
  if (channel.autoSchedulerSettings) {
    processed.auto_scheduler_settings = channel.autoSchedulerSettings
    processed.auto_scheduler_settings.as_depth_time_min = channel.autoSchedulerDepth
  }
  return processed
}

export const processRule = (r) => {
  const processed = {
    id: r.id,
    repeat: r.repeat,
    startTime: `${moment.utc(r.start_date * 1000).format('MMM D')}, ${moment.utc(r.start_at * 1000).format('HH:mm:ss')} UTC`,
    createTime: r.created_at,
    isFixed: r.is_fixed,
    type: r.type,
    repeatEvery: 1,
    repeatText: '',
    startDate: r.start_date,
    startAt: r.start_at,
    description: '',
  }
  if (r.type === 'once') {
    processed.description = `id=${processed.id}: Repeat once`
  }
  if (r.type === 'hourly') {
    processed.repeatEvery = Number(r.hourly.every_hour) || 1
    processed.repeatText = `Every ${processed.repeatEvery} hour(s)`
    const suffix = processed.repeatEvery === 1 ? 'hour' : 'hours'
    processed.description = `id=${processed.id}: every ${processed.repeatEvery} ${suffix}, ${processed.repeat} times`
  }
  if (r.type === 'daily') {
    processed.repeatEvery = Number(r.daily.every_day) || 1
    processed.repeatText = `Every ${processed.repeatEvery} day(s)`
    const suffix = processed.repeatEvery === 1 ? 'day' : 'days'
    processed.description = `id=${processed.id}: every ${processed.repeatEvery} ${suffix}, ${processed.repeat} times`
  }
  if (r.type === 'weekly') {
    const days = []
    if (r.weekly.sunday) days.push('Sun')
    if (r.weekly.monday) days.push('Mon')
    if (r.weekly.tuesday) days.push('Tue')
    if (r.weekly.wednesday) days.push('Wed')
    if (r.weekly.thursday) days.push('Thu')
    if (r.weekly.friday) days.push('Fri')
    if (r.weekly.saturday) days.push('Sat')
    processed.repeatEvery = days.join(', ')
    processed.repeatText = `Every ${processed.repeatEvery}`
    processed.description = `id=${processed.id}: every ${processed.repeatEvery}, ${processed.repeat} times`
  }
  if (r.type === 'monthly') {
    processed.repeatEvery = Number(r.monthly.every_month) || 1
    processed.repeatText = `Every ${processed.repeatEvery} month(s)`
    const suffix = processed.repeatEvery === 1 ? 'month' : 'months'
    processed.description = `id=${processed.id}: every ${processed.repeatEvery} ${suffix}, ${processed.repeat} times`
  }
  return processed
}

const processItem = (i) => ({
  id: i.id,
  type: i.type,
  name: i.name,
  description: i.description,
  startTime: i.start_time,
  streamURL: '',
})

export const processProgram = (p) => {
  const processed = {
    id: p.id,
    createTime: p.create_time,
    updateTime: p.update_time,
    type: p.type,
    startTime: p.start_time,
    endTime: p.end_time,
    assetId: p.asset_id,
    items: [],
    fixed: p.fixed || false,
    //
    subType: p.type,
    name: '',
    description: '',
    containsAd: false,
    containsBumper: false,
    tags: [],
    pubTime: '',
  }
  if (p.items) {
    processed.items = p.items.map((i) => processItem(i))
  }
  if (p.type === 'asset') {
    for (let i = 0; i < p.items.length; i += 1) {
      const item = p.items[i]
      if (item.type === 'vod') {
        processed.subType = item.type
        processed.name = item.name
        processed.description = item.description
      }
      if (item.type === 'ad') {
        processed.containsAd = true
      }
    }
  }

  const start = moment(processed.startTime).utc().unix() * 1000
  const end = moment(processed.endTime).utc().unix() * 1000

  processed.duration = end - start
  return processed
}

export const processItem2 = (i) => {
  const processed = {
    id: i.id,
    type: i.type,
    name: i.name,
    startTime: i.start_time,
    endTime: i.end_time,
    streamURL: '',
    duration: moment(i.end_time).utc().unix() * 1000 - moment(i.start_time).utc().unix() * 1000,
  }

  return processed
}

export const processProgram2 = (p) => {
  const processed = {
    id: p.id,
    type: p.type,
    name: p.name,
    startTime: p.start_time,
    endTime: p.end_time,
    assetId: p.asset_id || 0,
    items: [],
    fixed: p.fixed || false,
    //
    subType: p.type,
    description: '',
    containsAd: false,
    containsBumper: false,
    tags: [],
  }
  if (p.items) {
    processed.items = p.items.map((i) => processItem2(i))
  }
  if (p.type === 'asset' && p.items) {
    for (let i = 0; i < p.items.length; i += 1) {
      const item = p.items[i]
      if (item.type === 'vod') {
        processed.subType = item.type
      }
      if (item.type === 'ad') {
        processed.containsAd = true
      }
    }
  }

  const start = moment(processed.startTime).utc().unix() * 1000
  const end = moment(processed.endTime).utc().unix() * 1000

  processed.duration = end - start
  return processed
}

const processOption = (key, option) => ({
  key,
  description: option.description,
  required: option.is_required,
  assigned: '',
})

const processExampleItem = (key, value) => {
  const processed = {
    key: key.replace('channel/item/', ''),
    value: '',
  }
  if (typeof value === 'string') {
    processed.value = value
  } else if (Array.isArray(value)) {
    processed.value = value.join(', ')
  } else if (typeof value === 'object') {
    processed.value = JSON.stringify(value)
  }
  return processed
}

export const processMRSSImportResult = (importResult) => {
  const processed = {
    totalEntries: importResult.total_entries || 0,
    exampleItems: [],
    options: [],
    elements: [],
    channelTitle: '',
  }
  if (importResult.example && importResult.example.channel) {
    processed.channelTitle = importResult.example.channel['channel/title'] || ''
    if (importResult.example.channel['channel/item']) {
      for (let i = 0; i < importResult.example.channel['channel/item'].length; i += 1) {
        const itemValues = []
        // eslint-disable-next-line no-restricted-syntax
        for (const key in importResult.example.channel['channel/item'][i]) {
          if (!key.startsWith('channel/item')) {
            // eslint-disable-next-line no-continue
            continue
          }
          if (key === 'guid/attribute:isPermaLink' || key === 'media:content' || key === 'media:thumbnail') {
            // eslint-disable-next-line no-continue
            continue
          }
          itemValues.push(processExampleItem(key, importResult.example.channel['channel/item'][i][key]))
        }
        processed.exampleItems.push(itemValues)
      }
    }
  }
  if (importResult.options) {
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const property in importResult.options) {
      processed.options.push(processOption(property, importResult.options[property]))
    }
  }
  for (let i = 0; i < importResult.nodes.length; i += 1) {
    const el = importResult.nodes[i]
    if (!el.startsWith('channel/item')) {
      // eslint-disable-next-line no-continue
      continue
    }
    if (el === 'channel/item/guid/attribute:isPermaLink') {
      // eslint-disable-next-line no-continue
      continue
    }
    processed.elements.push(el.replace('channel/item/', ''))
  }
  return processed
}

export const processMediaSource = (source) => {
  const processed = {
    id: source.id,
    name: source.name,
    category: source.category,
    type: source.type,
    active: source.active || false,
    url: source.url,
    retentionPeriod: source.retention_period,
    lastImportTime: source.last_import_time,
    lastImportTime2: source.last_import_time2,
    tags: [],
    mappedElements: {},
    state: source.state,
    state2: source.state2,
    error: source.error || '',
    //
    totalItemCount: source.total || 0,
    processedItemCount: source.processed || 0,
  }
  if (source.tags) {
    processed.tags = source.tags.map((t) => processTag(t))
  }
  if (source.type === 'mrss') {
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in source.mrss_mapping) {
      if (source.mrss_mapping[key]) {
        processed.mappedElements[key] = source.mrss_mapping[key].replace('channel/item/', '')
      }
    }
  }
  return processed
}

export const processInstance = (i) => {
  const processed = {
    id: i.id,
    extId: i.ext_id,
    adminUsername: i.admin_username,
    loading: false,
  }
  return processed
}

export const processSource = (s) => {
  const processed = {
    id: s.id,
    extId: s.ext_id,
    name: s.name,
    type: s.type,
    lastImportTime: s.last_import_time,
    state: s.state || '',
    error: s.error || '',
    url: s.url || '',
    inputFtpStorage: s.input_ftp_storage || '',
    outputFtpStorage: s.output_ftp_storage || '',
    total: 0,
    video: 0,
    transcoded: 0,
    progress: 0,
    instances: [],
  }
  return processed
}

export const processSourceInstance = (s) => {
  const processed = {
    id: s.id,
    state: s.state || '',
    error: s.error || '',
    sourceId: s.source_id,
    instanceId: s.instance_id,
    instanceName: '',
    active: s.active,
    scPackageId: s.sc_package_extid || '',
    cdnTag: s.sc_cdn_tag || '',
    vastId: s.sc_vast_id || '',
    provider: s.provider || '',
    loading: false,
    deleted: s.deleted || false,
  }
  return processed
}
